// extracted by mini-css-extract-plugin
export var textInput = "_cr-0";